import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { map } from 'rxjs/operators';

export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if user is authenticated
  return authService.isAuthenticated().pipe(
    map(isAuthenticated => {
      if (!isAuthenticated) {
        // Capture the intended URL so the user can be redirected back after login
        router.navigate(['/login'], {
          queryParams: { redirectUrl: state.url },
        });
        return false;
      }
      return true;
    })
  );
};

